import {
    BOOKINGS_CREATE_FOR_DEPOSIT_START,
    BOOKINGS_CREATE_FOR_DEPOSIT_SUCCESS,
    BOOKINGS_CREATE_START,
    BOOKINGS_CREATE_SUCCESS,
    BOOKINGS_ERROR,
    BOOKINGS_RESET,
    BookingsAction
} from 'actions/bookings/BookingsActionsTypes';
import { BookingsState, BookingsStatus } from 'reducers/bookings/BookingsState';
import { Reducer } from 'redux';

const initialState: BookingsState = {
    loading: false,
    status: BookingsStatus.Initial
};

export const bookingsReducer: Reducer<BookingsState, BookingsAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case BOOKINGS_RESET:
            return initialState;
        case BOOKINGS_ERROR:
            return {
                ...state,
                loading: false,
                status: BookingsStatus.Error
            };
        case BOOKINGS_CREATE_START:
            return {
                ...state,
                loading: true,
                booking: undefined,
                status: BookingsStatus.CreateStart
            };
        case BOOKINGS_CREATE_SUCCESS:
            return {
                ...state,
                loading: false,
                booking: action.payload.booking,
                status: BookingsStatus.CreateSuccess
            };
        case BOOKINGS_CREATE_FOR_DEPOSIT_START:
            return {
                ...state,
                loading: true,
                booking: undefined,
                status: BookingsStatus.CreateDepositStart
            };
        case BOOKINGS_CREATE_FOR_DEPOSIT_SUCCESS:
            return {
                ...state,
                loading: false,
                booking: action.payload.booking,
                status: BookingsStatus.CreateDepositSuccess
            };
        default:
            return state;
    }
};
